export const SCHEDULER_DAY_SPAN: number = 3;

export const MONTHS: [string, string, string, string, string, string, string, string, string, string, string, string] = [
    'Styczeń',
    'Luty',
    'Marzec',
    'Kwiecień',
    'Maj',
    'Czerwiec',
    'Lipiec',
    'Sierpień',
    'Wrzesień',
    'Październik',
    'Listopad',
    'Grudzień'
];

export const WEEKDAYS_SHORT: [string, string, string, string, string, string, string] = [
    'Nd', 'Pon', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb'
];

export const WEEKDAYS_LONG: [string, string, string, string, string, string, string] = [
    'Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'
];


// WEBPACK FOOTER //
// ./src/constants/DateConsts.tsx